<div class="p-2">
    <div class="d-flex justify-content-between align-items-center header mb-3">
        <p class="p-0 m-0">Încărcați imaginile</p>
        <div>
            <button type="button" class="close d-flex align-items-center" aria-label="Close" (click)="closeDialog()" [disabled]="isLoading">
                <span class="close-icon" aria-hidden="true">&times;</span>
                <span class="close-text">&nbsp;&nbsp;ÎNCHIDE</span>
            </button>
        </div>
    </div>
    
    <form [formGroup]="form">
        <div class="upload d-flex flex-column">
            <div class="upload-header d-flex flex-row justify-content-between align-items-center">
                <p class="m-0">Imagini</p>
                <button type="button" class="upload-btn" (click)="fileInput.click()">
                    <mat-icon class="upload-icon">cloud_upload</mat-icon>
                    ÎNCARCĂ
                </button>
            </div>
            <div class="upload-files" *ngIf="form.value.files && form.value.files.length > 0">
                <div class="upload-file d-flex flex-row justify-content-between align-items-center" *ngFor="let uploadedFile of form.value.files; let i = index">
                    <span class="upload-file-name">
                        {{ (uploadedFile.name && uploadedFile.name.length > 50) ? (uploadedFile.name | slice: 0:50) + '..' : (uploadedFile.name) }}
                    </span>
        
                    <mat-spinner diameter="32" *ngIf="uploading[i]"></mat-spinner>
                    <div>
                        <button class="upload-file-delete d-flex" type="button" matTooltip="Șterge fișierul încărcat" (click)="removeFile(i)">
                            <img class="btn-img" src="../../../assets/icons/delete.svg" alt="" />
                        </button>
                    </div>
                </div>
            </div>
        
            <input type="file" accept="image/png, image/jpeg, image/gif, image/jpg" id="upload-file-input-0" #fileInput
                name="fileInput" (change)="addFile($event)" multiple style="display: none">
        </div>
    </form>
    
    <button type="button" class="btn btn-md btn-success my-3 pull-right" (click)="submitForm()" [disabled]="isLoading || form.get('files')?.value == []">
        Încarcă
    </button>
</div>
